<div [ngClass]="{'toasts':messageType == 'Toast'}" *ngIf="messages && messages.length > 0">
    <xrm-notification *ngFor="let message of messages" [message]="message" (close)="onCloseMessage($event)" class="{{severityClass(message)}}"></xrm-notification>
</div>